import __request__ from "routing/request";
export function getPaginatedFiltersForStream(streamId, paginationparameters) {
  return __request__("GET", `/streams/${streamId}/destinations/filters`, paginationparameters, {}, {
    "Accept": ["application/json"]
  });
}
export function createFilter(streamId, JSONbody) {
  return __request__("POST", `/streams/${streamId}/destinations/filters`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function updateFilter(streamId, filterId, JSONbody) {
  return __request__("PUT", `/streams/${streamId}/destinations/filters/${filterId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteFilter(streamId, filterId) {
  return __request__("DELETE", `/streams/${streamId}/destinations/filters/${filterId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getFilter(streamId, filterId) {
  return __request__("GET", `/streams/${streamId}/destinations/filters/${filterId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getPaginatedFiltersForStreamAndTarget(streamId, targetId, paginationparameters) {
  return __request__("GET", `/streams/${streamId}/destinations/target/${targetId}/filters`, paginationparameters, {}, {
    "Accept": ["application/json"]
  });
}
